var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-img',{attrs:{"id":"imageFeature","fluid":"","src":_vm.image_url},on:{"load":_vm.onImageLoad}}),_c('canvas',{staticClass:"canvas",attrs:{"id":"canvas"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }